import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { queryClient, persister } from './query-client';
import { DAY } from '@shared/utils';

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: 1 * DAY,

        buster: 'v1',

        dehydrateOptions: {
          shouldDehydrateQuery: (query) =>
            query.meta?.persist === true &&
            query.state.status === 'success',
        },
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
};